import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { formatAmount } from "../../utils/tableUtils";
import styles from "../../pages/css/Dashboard.module.css";

const WalletCardPanel = ({ dashboardData, textFadeUpVariants }) => {
  return (
    <div className={styles.myCardPanel}>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className={styles.myCardChip} title="VIP Card Chip">
          <i className="fas fa-microchip"></i>
        </div>
        <span className={`${styles.badgeCustom} ${styles.badgeUsdt}`}>BINAXPAY VIP</span>
      </div>
      <div className={styles.myCardBalanceLabel}>Available Balance</div>
      <motion.div
        className={styles.myCardBalance}
        variants={textFadeUpVariants}
      >
        {formatAmount(dashboardData?.walletBalance)}
      </motion.div>

      <div
        className="d-flex justify-content-between align-items-center mb-3"
        style={{ fontSize: "0.825rem", color: "#A3A3A3" }}
      >
        <span>Total Deposits</span>
        <span style={{ color: "#FFFFFF", fontWeight: "700" }}>
          {formatAmount(dashboardData?.totalDeposit)}
        </span>
      </div>

      <div className={styles.quickActionsRow}>
        <Link to="/self_addresses" className={styles.btnActionPrimary}>
          <i className="fas fa-plus-circle"></i> Deposit
        </Link>
        <Link to="/payout_transactions" className={styles.btnActionOutline}>
          <i className="fas fa-history"></i> History
        </Link>
      </div>
    </div>
  );
};

export default WalletCardPanel;
